export const environment = {
    // production
    // production: true,
    // production_domain: 'https://api-r12network.numeddatacenter.com/dashboard-api',


    
    // Uat
    production: false,
    development_domain: 'https://api.numedapp.com/api-r12network-uat',
    development_domain_microservice: 'https://microservice.numeddatacenter.com/api/microservice/dky/',
    development_telequeue: 'https://api.numedapp.com/api-r12network-uat',
    development_socket_payment: 'https://api.numedapp.com/api-r12network-uat'

}

export const config = {
    NODE_ENV: process.env.REACT_APP_NODE_ENV,
    APP_URL: process.env.REACT_APP_URL,
    MICROSERVICE_URL: process.env.REACT_APP_MICROSERVICE_URL,
    TELEQUEUE_URL: process.env.REACT_APP_TELEQUEUE_URL,
    STORAGE_ENDPOINT: process.env.REACT_APP_STORAGE_ENDPOINT,
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
    SOCKET_URL: process.env.REACT_APP_SOCKET_URL,

}

